<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="用户id：" prop="user_id">
                <span>{{model.user_id}}</span>
            </el-form-item>
            <el-form-item label="名称：" prop="user_name">
                <span>{{model.user_name}}</span>
            </el-form-item>
            <el-form-item label="登录时间：" prop="addtime">
                <span>{{model.addtime}}</span>
            </el-form-item>
            <el-form-item label="IP：" prop="ipaddress">
                <span>{{model.ipaddress}}</span>
            </el-form-item>
            <el-form-item label="1 后台 2 前台：" prop="ltype">
                <span>{{model.ltype}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'loginLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                user_id: '',
                user_name: '',
                addtime: '',
                ipaddress: '',
                ltype: '',
            },
            getObj:{
                url:'/api/admin/loginlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>